import { Form, Input, InputNumber, Radio, Select } from "antd";
import { useEffect } from "react";

export default function HealthForm({ form, item, sceneList }: any) {
    useEffect(() => {
        if (item.id) {
            form.setFieldsValue(item);
        }
    }, []);

    return (
        <Form form={form} size="small" name="HealthForm" labelCol={{ span: 6 }} wrapperCol={{ span: 15 }} autoComplete="off">
            <Form.Item label="任务组标题" name="title" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入任务组标题" />
            </Form.Item>
            <Form.Item label="任务组标识" name="key">
                <Input placeholder="请输入任务组标识" />
            </Form.Item>
            <Form.Item label="场景" name="sceneId" rules={[{ required: true, message: '不能为空' }]}>
                <Select
                    placeholder="请选择场景"
                    options={sceneList.map((item: any) => ({
                        label: item.title,
                        value: item.id,
                    }))}
                />
            </Form.Item>
            <Form.Item label="备注" name="remark">
                <Input.TextArea placeholder="请输入备注信息" autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="循环周期" name="cyclePeriod" initialValue={1} rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入循环周期(单位天，默认1天)" precision={0} style={{ width: '100%' }} addonAfter={'天'} />
            </Form.Item>
            <Form.Item label="是否默认任务组" name="defaultState" rules={[{ required: true, message: '不能为空' }]}>
                <Radio.Group options={[
                    { label: '是', value: true },
                    { label: '否', value: false },
                ]}
                />
            </Form.Item>
            <Form.Item
                label="最小支持版本号"
                name="minVersionCode"
            >
                <InputNumber
                    placeholder="请输入最小支持版本号, 如100"
                    style={{ width: '100%' }}
                    onChange={() => form.validateFields(['maxVersionCode'])}
                />
            </Form.Item>
            <Form.Item
                label="最大支持版本号"
                name="maxVersionCode"
                rules={[
                    {
                        validator: async (_, value) => {
                            const minVersion = form.getFieldValue('minVersionCode');
                            if (value && minVersion && value < minVersion) {
                                throw new Error('最大支持版本号必须超过最小支持版本号');
                            }
                        },
                    },
                ]}
            >
                <InputNumber placeholder="请输入最大支持版本号, 如110" style={{ width: '100%' }} />
            </Form.Item>
        </Form>
    )
}